import { render, staticRenderFns } from "./SNV.vue?vue&type=template&id=428bee2a&scoped=true"
import script from "./SNV.vue?vue&type=script&lang=js"
export * from "./SNV.vue?vue&type=script&lang=js"
import style0 from "./SNV.vue?vue&type=style&index=0&id=428bee2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428bee2a",
  null
  
)

export default component.exports